// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"1ca8d595","453":"d54cfc71"}[chunkId] + ".chunk.js";
};